// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__fKou_","spin":"styles_spin__0vWFv"};